if ($('.funding-detail').length > 0) {
    $('#funding-page').remove();
}
function fundingSearchCallBack() {
    $("#GridContent").remove();
    $(".article-card").slice(0, 12).show();
    if ($(".article-card").length > 0) {
        $("#clear-search-form").addClass('show');
    }

    if ($(".article-card:hidden").length == 0) {
        $("#load-more").remove();
    }

    matchCardHeights();

    $("#load-more").on('click', function (e) {
        e.preventDefault();
        $(".article-card:hidden").slice(0, 12).show();
        if ($(".article-card:hidden").length == 0) {
            $("#load-more").remove();
        }
    });

    $('#location-reload').on('click', function () {
        window.history.replaceState(null, null, window.location.pathname);
        location.reload();
    });
}
window.fundingSearchCallBack = fundingSearchCallBack;